import { defineComponent as s, createElementBlock as c, openBlock as n, createElementVNode as e, createVNode as t, unref as r } from "vue";
import { ScalarHotkey as i } from "@scalar/components";
import l from "../assets/keycap.ascii.js";
import o from "./ScalarAsciiArt.vue.js";
const p = { class: "flex-center flex w-full scale-75" }, m = { class: "relative" }, d = { class: "relative -ml-12" }, h = /* @__PURE__ */ s({
  __name: "EmptyState",
  setup(_) {
    return (f, a) => (n(), c("div", p, [
      e("div", m, [
        t(r(i), {
          class: "keycap-hotkey right-14 border-transparent py-0 text-xl",
          hotkey: ""
        }),
        t(o, {
          art: r(l),
          class: "text-c-3 !leading-[6px]"
        }, null, 8, ["art"])
      ]),
      e("div", d, [
        a[0] || (a[0] = e("div", { class: "keycap-hotkey right-16 text-xl" }, "K", -1)),
        t(o, {
          art: r(l),
          class: "keycap-n !leading-[6px]"
        }, null, 8, ["art"])
      ])
    ]));
  }
});
export {
  h as default
};
